import {
	Box,
	FormControl,
	FormLabel,
	IconButton,
	Typography,
} from '@mui/material';
import React, { useId } from 'react';
import { CloseIcon } from '../../mui/Icons';
import styles from './AvatarSelected.module.scss';

export type ProfileImageSelection = {
	imageFile: File;
	imagePositionX: number;
	imagePositionY: number;
	imageRotation: number;
	imageScale: number;
	originalImage: File;
};

export type AvatarSelectedProps = {
	value?: string;
	onRemove?: () => void;
	label: string;
};

const AvatarSelected: React.FC<AvatarSelectedProps> = ( {
	value,
	onRemove,
	label,
} ) => {
	const buttonId = useId();
	return (
		<FormControl className={ styles.container } data-cy='profileImageSelected'>
			<FormLabel htmlFor={ buttonId }>{ label }</FormLabel>
			<Box className={ styles.row }>
				<Typography className={ styles.filename }>{ value }</Typography>
				<IconButton id={ buttonId } onClick={ onRemove } className={ styles.icon }>
					<CloseIcon />
				</IconButton>
			</Box>
		</FormControl>
	);
};

export default AvatarSelected;
